export const formatter = new Intl.NumberFormat("en-UK",{
    style: "currency",
    currency: "EUR"
})